var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmailGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.464 13.158H2.937a2.924 2.924 0 01-2.936-2.936V2.936A2.924 2.924 0 012.937 0h11.636a2.924 2.924 0 012.936 2.936v7.286c-.109 1.631-1.414 2.936-3.045 2.936zM2.937 1.196c-.979 0-1.849.87-1.849 1.849v7.286c0 .978.87 1.848 1.85 1.848h11.635c.978 0 1.848-.87 1.848-1.848V3.045c0-.979-.87-1.849-1.848-1.849H2.937z",
    fill: "#888"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.183 3.804L10.44 7.72c-.435.326-1.088.435-1.74.435-.653 0-1.196-.109-1.74-.435L.219 3.804l.543-.978L7.505 6.74c.652.327 1.74.327 2.283 0l6.742-3.914.653.978z",
    fill: "#888"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.893 6.525l-.842-.687-4.676 5.728.843.688 4.675-5.729zm11.184 5.066L12.4 5.863l-.842.688 4.676 5.728.843-.688z",
    fill: "#888"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailGrey);
export default __webpack_public_path__ + "static/media/email-grey.ae3cc6e8a556431909774359638f0cbb.svg";
export { ForwardRef as ReactComponent };